import React from "react";
import { useNavigate } from "react-router-dom";
import GenericModal from "@ui-components/Modal/GenericModal";
import { FailoverTableRow } from "./Types";

/**
 * The full record of one outage. Shared by the classic Outages table and the
 * action center's "Attention required" list, so both open the same thing.
 */
export function OutageDetailsModal({
  outage,
  onClose,
}: {
  /** The outage to show; `null` closes the modal. */
  outage: FailoverTableRow | null;
  onClose: () => void;
}) {
  const navigate = useNavigate();

  return (
    <GenericModal isOpen={outage !== null} onClose={onClose} title="Outage Details" size="lg">
      {outage && (
        <div className="space-y-4 p-4">
          <div className="flex flex-wrap gap-x-6 gap-y-1 text-sm text-semantic-text-secondary">
            {outage.incidentId && (
              <span><strong>ID:</strong> {outage.incidentId}</span>
            )}
            <span><strong>Date:</strong> {outage.date}</span>
            {outage.site && outage.site !== "–" && (
              <span><strong>Site:</strong> {outage.site}</span>
            )}
            <span><strong>Duration:</strong> {outage.duration}</span>
          </div>

          {outage.detail && (
            <div>
              <p className="text-sm text-semantic-text-secondary whitespace-pre-wrap text-justify">
                {outage.detail}
              </p>
            </div>
          )}

          <div className="pt-3 border-t border-gray-200">
            <p className="text-xs text-semantic-text-secondary">
              For more information, open a{" "}
              <a
                href="/support/request"
                className="underline hover:text-semantic-text-primary"
                onClick={(e) => {
                  e.preventDefault();
                  onClose();
                  navigate("/support/request");
                }}
              >
                help request
              </a>
              .
            </p>
          </div>
        </div>
      )}
    </GenericModal>
  );
}
